<template>
  <div class="menu-wrapper">
    <template>
      <el-submenu :index="item.name + ''">
        <div
          slot="title"
          :class="{ 'is-active': item.meta.title === basic }"
          @click.stop="goNext(item)"
        >
          <i :class="item.icon" v-if="item.icon"></i>
          <p>{{ item.meta.title }}</p>
        </div>
        <!-- <sidebarItem
          v-for="(i, index) in item.children"
          :key="index"
          :item="i"
          :basePath="resolvePath(item && item.path)"
        ></sidebarItem> -->
      </el-submenu>
    </template>
  </div>
</template>

<script>
import path from "path";
import { mapState } from "vuex";

export default {
  name: "sidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  created(){
        let userinfo = this.$store.state.userInfo.userinfo;
        if (userinfo) {
            this.token=userinfo.accessToken;
        }
  },
  computed: {
    ...mapState({
      basic: (state) => state.routerInfo.basic,
    }),
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },
  methods: {
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
    goNext(data) {
        zhuge.track(`用户中心_左导航${data.meta.title}`, {'渠道': this.channelCodeValue})
      if (data.isOpen) {
        if (data.children) {
          if (data.children[0].href) {
            window.open(process.env.VUE_APP_TSA+data.children[0].href)
              //process.env.VUE_APP_USERCENTERUI + data.children[0].href;
          } else {
            this.$router.push({ path: data.children[0].path });
          }
        }else{
            if (data.target === '_blank') {
                let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
                window.open(data.path+"?sourceType="+sourceType)
            }else{
                this.$router.push({ path: data.path});
            }
        }
      }else{
         this.$msg("功能待开放，敬请期待！",'warning');
      }
    },
  },
};
</script>
